import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Dropdown
} from 'semantic-ui-react'

const ModDrugLabInteractionUX = (props: any) => {
    return(
      <div
        id="ModDrugLabInteractionUX-div-0"
        style={{width: "100%", height: "100%"}}>
        <div
          id="ModDrugLabInteractionUX-div-1"
          style={{backgroundColor: "#f69529eb", color: "white", fontWeight: "bold", fontSize: "22px", padding: "15px"}}>
          {props.languageUX === "en" ? "Found a list of medications associated with abnormal lab values." : "พบรายการยาที่เกี่ยวข้องกับค่า Lab ผิดปกติ"}
        </div>
        <div
          id="ModDrugLabInteractionUX-div-2"
          style={{width: "100%"}}>
          {props.drugLabInteractionList}
        </div>
        <div
          id="ModDrugLabInteractionUX-div-3"
          style={{fontWeight: "bold", fontSize: "18px", padding: "15px 20px"}}>
          {props.orderItemId? "เหตุผลการสั่งใช้ยาจากแพทย์" : "หากต้องการยืนยันการสั่งกรุณาระบุเหตุผล"}
        </div>
        <div
          id="ModDrugLabInteractionUX-div-4"
          style={{width: "100%", padding: "10px 30px"}}>
          
          <Dropdown
            allowAdditions={true}
            disabled={!props.isEditable}
            fluid={true}
            id="ModDrugLabInteractionUX-Dropdown-11"
            onAddItem={props.onAddItem}
            onChange={props.onNoteChange}
            options={props.drugLabReasonOptions}
            search={true}
            selection={true}
            style={{width: "100%"}}
            value={props.note}>
          </Dropdown>
        </div>
        <div
          id="ModDrugLabInteractionUX-div-5"
          style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
          
          <div
            id="ModDrugLabInteractionUX-div-7"
            style={{padding: "15px 10px"}}>
            
            <Button
              className="inverted big"
              color="green"
              disabled={props.orderItemId && !props.note}
              id="ModDrugLabInteractionUX-Button-9"
              onClick={props.onApprove}
              style={{display: props.isEditable? ""  : "none"}}>
              {props.orderItemId?"แก้ไข" : "ยืนยัน"}
            </Button>
          </div>
          <div
            id="ModDrugLabInteractionUX-div-8"
            style={{padding: "15px 10px"}}>
            
            <Button
              className="inverted big"
              color="red"
              id="ModDrugLabInteractionUX-Button-10"
              onClick={props.onDeny}>
              {props.isEditable? "ยกเลิก" : "ปิดหน้าต่าง"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default ModDrugLabInteractionUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDrugLabInteractionUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "พบรายการยาที่เกี่ยวข้องกับค่า Lab ผิดปกติ",
          "valueEN": "Found a list of medications associated with abnormal lab values."
        },
        "id": {
          "type": "value",
          "value": "ModDrugLabInteractionUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"#f69529eb\", color: \"white\", fontWeight: \"bold\", fontSize: \"22px\", padding: \"15px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugLabInteractionList"
        },
        "id": {
          "type": "value",
          "value": "ModDrugLabInteractionUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderItemId? \"เหตุผลการสั่งใช้ยาจากแพทย์\" : \"หากต้องการยืนยันการสั่งกรุณาระบุเหตุผล\""
        },
        "id": {
          "type": "value",
          "value": "ModDrugLabInteractionUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"18px\", padding: \"15px 20px\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugLabInteractionUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", padding: \"10px 30px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugLabInteractionUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"center\", alignItems: \"center\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugLabInteractionUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px 10px\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugLabInteractionUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px 10px\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Button",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderItemId?\"แก้ไข\" : \"ยืนยัน\""
        },
        "className": {
          "type": "value",
          "value": "inverted big"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.orderItemId && !props.note"
        },
        "id": {
          "type": "value",
          "value": "ModDrugLabInteractionUX-Button-9"
        },
        "onClick": {
          "type": "code",
          "value": "props.onApprove"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: props.isEditable? \"\"  : \"none\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Button",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.isEditable? \"ยกเลิก\" : \"ปิดหน้าต่าง\""
        },
        "className": {
          "type": "value",
          "value": "inverted big"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "ModDrugLabInteractionUX-Button-10"
        },
        "onClick": {
          "type": "code",
          "value": "props.onDeny"
        },
        "size": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Dropdown",
      "parent": 4,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.isEditable"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModDrugLabInteractionUX-Dropdown-11"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddItem"
        },
        "onChange": {
          "type": "code",
          "value": "props.onNoteChange"
        },
        "options": {
          "type": "code",
          "value": "props.drugLabReasonOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.note"
        }
      },
      "seq": 11,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 55,
  "isMounted": false,
  "memo": false,
  "name": "ModDrugLabInteractionUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 60
}

*********************************************************************************** */
